export { default as Img200 } from './processed/200/vegamagic.jpg';
export { default as Img400 } from './processed/400/vegamagic.jpg';
export { default as Imgthumb } from './processed/thumb/vegamagic.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/vegamagic.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/vegamagic.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      227,
      53,
      50
    ],
    "_population": 32,
    "_hsl": [
      0.0028248587570621504,
      0.7596566523605149,
      0.5431372549019607
    ]
  },
  "LightVibrant": {
    "_rgb": [
      247,
      109,
      84
    ],
    "_population": 81,
    "_hsl": [
      0.025562372188139056,
      0.9106145251396648,
      0.6490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      109,
      51,
      31
    ],
    "_population": 621,
    "_hsl": [
      0.04273504273504275,
      0.5571428571428572,
      0.2745098039215686
    ]
  },
  "Muted": {
    "_rgb": [
      105,
      109,
      172
    ],
    "_population": 595,
    "_hsl": [
      0.6567164179104478,
      0.2875536480686696,
      0.5431372549019609
    ]
  },
  "LightMuted": {
    "_rgb": [
      209,
      188,
      222
    ],
    "_population": 255,
    "_hsl": [
      0.7696078431372548,
      0.33999999999999997,
      0.803921568627451
    ]
  },
  "DarkMuted": {
    "_rgb": [
      52,
      52,
      77
    ],
    "_population": 194,
    "_hsl": [
      0.6666666666666666,
      0.19379844961240308,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/vegamagic.js